import { VENDORS_ACTIONS, initialVendorsState } from './vendors.types'

/**
 * @param {import('./vendors.types').VendorsSlice} state
 * @param {Object} action
 */
export function vendorsReducer(state = initialVendorsState, { type, payload }) {
  switch (type) {
    case VENDORS_ACTIONS.SET_VENDOR:
      return {
        ...state,
        data: {
          ...state.data,
          [payload.id]: payload
        }
      }

    case VENDORS_ACTIONS.SET_VENDORS:
      return {
        ...state,
        data: Array.isArray(payload) ? payload.reduce((acc, vendor) => ({ ...acc, [vendor.id]: vendor }), {}) : payload
      }

    case VENDORS_ACTIONS.SET_STATUS:
      return { ...state, status: payload }

    case VENDORS_ACTIONS.SET_ERRORS:
      return { ...state, errors: [payload, ...state.errors] }

    case VENDORS_ACTIONS.CLEAR_ERRORS:
      return { ...state, errors: [] }

    default:
      return state
  }
}
